<div class="sync-area">
  <mat-icon
    *ngIf="group?.syncStatus == 'fail'"
    style="color: red"
    matTooltipClass="customMatTooltip"
    [matTooltip]="group?.message"
    matTooltipPosition="below"
  >
    sync_problem_outlined
  </mat-icon>
  <span class="sync-text"> Last Sync: </span>
  <mat-spinner
    *ngIf="!momentAgo || group?.syncStatus == 'progress'"
    [diameter]="15"
    style="margin-right: 5px"
    data-testId="sync-spinner"
  ></mat-spinner>
  <span class="sync-moment" data-testId="last-sync-message">
    {{ momentAgo }}
  </span>
</div>
